import React from 'react';
import { Phone, Calendar, MapPin, FileCheck } from 'lucide-react';

const SCHRITTE = [
  {
    nummer: '1',
    icon: Phone,
    title: 'Kontakt aufnehmen',
    text: 'Rufen Sie an oder schreiben Sie per WhatsApp. Wir klären den Schaden und Ihre Situation.'
  },
  {
    nummer: '2',
    icon: Calendar,
    title: 'Termin abstimmen',
    text: 'Wir vereinbaren gemeinsam Ort und Zeitfenster – flexibel nach Ihrer Verfügbarkeit.'
  },
  {
    nummer: '3',
    icon: MapPin,
    title: 'Begutachtung vor Ort',
    text: 'Der Sachverständige dokumentiert den Schaden dort, wo sich das Fahrzeug befindet.'
  },
  {
    nummer: '4',
    icon: FileCheck,
    title: 'Gutachten erstellen & bereitstellen',
    text: 'Sie erhalten das fertige Gutachten zur Vorlage bei der Versicherung.'
  }
];

export const WieFunktioniertEs = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Ablauf
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            So funktioniert die Begutachtung bundesweit
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {SCHRITTE.map((schritt, index) => {
            const Icon = schritt.icon;
            return (
              <div key={index} className="bg-white border border-gray-100 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 bg-brand-green text-white rounded-xl flex items-center justify-center font-bold text-lg flex-shrink-0">
                    {schritt.nummer}
                  </div>
                  <div className="w-12 h-12 bg-brand-green/10 rounded-xl flex items-center justify-center border border-brand-green/15 flex-shrink-0">
                    <Icon className="w-6 h-6 text-brand-green" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 tracking-tight">{schritt.title}</h3>
                <p className="text-gray-600 leading-relaxed text-[15px]">{schritt.text}</p>
              </div>
            );
          })}
        </div>

        {/* AI-Kurzantwort */}
        <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-xl p-6 max-w-3xl mx-auto">
          <p className="text-sm font-semibold text-brand-green-dark mb-2">In Kürze:</p>
          <p className="text-gray-700 leading-relaxed text-[15px]">
            Kontakt → Termin → Begutachtung → Gutachten.
          </p>
        </div>
      </div>
    </section>
  );
};